import React from "react";
import { RouterProvider } from "@tanstack/react-router";
import { HelmetProvider } from "react-helmet-async";
import { router } from "./router";
// import initSmoothScroll from "./utils/smoothScroll";

function App() {
  // React.useEffect(() => {
  //   initSmoothScroll();
  // }, []);

  // check if there exist a key products in local storage
  if (!localStorage.getItem("products")) {
    localStorage.setItem("products", JSON.stringify([]));
  }

  React.useEffect(() => {
    let scrollTimeout;
    const handleScroll = () => {
      if (!document.body.classList.contains("is-scrolling")) {
        document.body.classList.add("is-scrolling");
      }
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        document.body.classList.remove("is-scrolling");
      }, 150);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);

  // Lazy load and initialize AOS when browser is idle or after a short delay
  React.useEffect(() => {
    const initAOS = () => {
      Promise.all([
        import("aos"),
        import("aos/dist/aos.css")
      ]).then(([AOSModule]) => {
        const AOS = AOSModule.default || AOSModule;
        AOS.init({
          duration: 1000,
          once: true,
        });
      });
    };

    if (typeof window !== "undefined") {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(() => {
          setTimeout(initAOS, 1000);
        });
      } else {
        setTimeout(initAOS, 2000);
      }
    }
  }, []);

  return (
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  );
}

export default App;

